import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { ClinicAgentProvider } from './contexts/ClinicAgentContext';
import Login from './Login';
import AppShell from './components/AppShell';
import Dashboard from './pages/Dashboard';
import PatientsList from './pages/PatientsList';
import PatientDetail from './pages/PatientDetail';
import InvitesList from './pages/InvitesList';
import ResourcesPage from './pages/ResourcesPage';
import AgentConfigPage from './pages/AgentConfigPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <ClinicAgentProvider>
        <Router>
          <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/app" element={<AppShell />}>
            <Route index element={<Dashboard />} />
            <Route path="patients" element={<PatientsList />} />
            <Route path="patients/:id" element={<PatientDetail />} />
            <Route path="invites" element={<InvitesList />} />
            <Route path="resources" element={<ResourcesPage />} />
            <Route path="agent-config" element={<AgentConfigPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </Router>
      </ClinicAgentProvider>
    </AuthProvider>
  );
}

export default App;
